// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});


document.addEventListener("DOMContentLoaded", function () {
  function updateLowStockMessage(container, variant, threshold = 3) {
    if (!container || !variant) return;

    const countEl = container.querySelector(".low-stock-count");

    const shouldShow =
      variant.inventory_management === "shopify" &&
      variant.inventory_policy !== "continue" &&
      Number(variant.inventory_quantity) > 0 &&
      Number(variant.inventory_quantity) <= threshold;

    if (shouldShow) {
      if (countEl) {
        countEl.textContent = variant.inventory_quantity;
      }
      container.style.display = "";
    } else {
      container.style.display = "none";
    }
  }

  document.addEventListener("product:variant-change", function (evt) {
    const variant = evt.detail && evt.detail.variant;
    if (!variant) return;

    document.querySelectorAll(".low-stock-message").forEach((container) => {
      updateLowStockMessage(container, variant, 3);
    });
  });
});

document.addEventListener("product:variant-change", function (evt) {
  var variant = evt.detail.variant;
  var form = evt.target;

  // Zoek het dichtstbijzijnde low-stock element binnen hetzelfde product-formulier
  var productEl = form.closest("[data-product-id]") || form.closest("[data-section-id]");
  var el = productEl
    ? productEl.querySelector(".low-stock-message")
    : document.querySelector(".low-stock-message[data-product='" + variant.product_id + "']");

  if (!el) return;

  var count = el.querySelector(".low-stock-count");

  var show =
    variant.inventory_management === "shopify" &&
    variant.inventory_policy !== "continue" &&
    variant.inventory_quantity > 0 &&
    variant.inventory_quantity <= 5;

  el.style.display = show ? "" : "none";

  if (count) {
    count.textContent = variant.inventory_quantity;
  }
});